import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ["element"];

	connect() {
		const els = this.elementTargets ?? [];
		els.forEach((el) => {
			el.addEventListener('dblclick', (e) => {
				e.preventDefault();
			}, {passive: false});
		});
	}
}
